import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'
import switchFunc from 'lib/function/switchFunc'

export const EXPERIENCE_PRODUCT_TYPE_ALWAYS_ON = 'always_on'
export const EXPERIENCE_PRODUCT_TYPE_FLASH = 'flash'
export const EXPERIENCE_PRODUCT_TYPE_CHANNEL_MANAGER = 'channel_manager'
export const EXPERIENCE_PRODUCT_TYPE_TRANSFER = 'transfer'
export const EXPERIENCE_PRODUCT_TYPES: Array<App.ExperienceProductType> = [EXPERIENCE_PRODUCT_TYPE_ALWAYS_ON, EXPERIENCE_PRODUCT_TYPE_FLASH, EXPERIENCE_PRODUCT_TYPE_CHANNEL_MANAGER]
export const EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW = 5
export const EXPERIENCE_GIFT_SCHEDULE_DATE_LIMIT_BEFORE_EXPIRATION_DATE = 14
export const EXPERIENCE_ANY_DATE = 'any'
export const EXPERIENCE_TRANSFER_ID = 36
export const EXPERIENCE_CANCELLATION_REASON_DOWNGRADED = 'downgraded'

export const EXPERIENCE_WL_DESTINATIONS: Array<App.Place> = [
  { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
  { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
  { id: 'le_b96d145f6c31e35755f4a6841574ba37', name: 'Brisbane' },
  { id: 'le_bac732346917b0a1231354ef55faf00a', name: 'Gold Coast' },
  { id: 'le_f4c2c73d7fe5eb38fd83d32a61604247', name: 'Adelaide' },
  { id: 'le_7c27cf9f8fe09724bb754e474610eb0e', name: 'Perth' },
  { id: 'le_8f85517967795eeef66c225f7883bdcb', name: 'Thailand' },
  { id: 'le_64930b7151b6bc3e289f37d5da62ac9f', name: 'Bali' },
  { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
]
export const EXPERIENCE_LE_DESTINATIONS: Array<App.Place> = [
  { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
  { id: 'le_9fc3d7152ba9336a670e36d0ed79bc43', name: 'New Zealand' },
  { id: 'le_72b32a1f754ba1c09b3695e0cb6cde7f', name: 'Fiji' },
  { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
  { id: 'le_64930b7151b6bc3e289f37d5da62ac9f', name: 'Bali' },
  { id: 'le_8f85517967795eeef66c225f7883bdcb', name: 'Thailand' },
  { id: 'le_bac732346917b0a1231354ef55faf00a', name: 'Gold Coast' },
  { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
]

export const destinationsMap = switchFunc<Array<App.Place>, App.BrandName>({
  luxuryescapes: EXPERIENCE_LE_DESTINATIONS,
  treatmetravel: [
    { id: 'le_464adf7b911508701f4c4e70eab19a6e', name: 'Auckland' },
    { id: 'le_1e15efc3fac4ba31daa6f91082c97e97', name: 'Christchurch' },
    { id: 'le_5a4773830c5a9191a6bd6c301d060ad2', name: 'Queenstown' },
    { id: 'le_9fc3d7152ba9336a670e36d0ed79bc43', name: 'New Zealand' },
    { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
    { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
    { id: 'le_b96d145f6c31e35755f4a6841574ba37', name: 'Brisbane' },
    { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
  ],
},
EXPERIENCE_WL_DESTINATIONS)

export const EXPERIENCE_SEARCH_TYPES: Array<App.SearchType> = ['destination', 'experience']

export const EXPERIENCE_TYPEAHEAD_SEARCH_TYPES: Array<App.SearchPlaceType> = [
  'province_state',
  'neighborhood',
  'city',
  'multi_city_vicinity',
  'high_level_region',
  'country',
  'continent',
  'colloquial_area',
  'le_experience',
  'channel_experience',
]

export const AnythingCategory: App.ExperienceItemCategory = {
  id: 999,
  imageId: '',
  level: 'parent',
  name: 'Anything',
}

export enum ExperienceBookingType {
  BUY_NOW_BOOK_LATER = 'buy_now_book_later',
  INSTANT_BOOKING = 'instant_booking',
}

export const EXP_CATEGORY_AIRPORT_TRANSFER_ID = 36
export const EXP_CATEGORY_AIRPORT_LOUNGE_ID = 46
export const EXP_CATEGORY_WATER_TRANSFER_ID = 55
export const EXP_CATEGORY_PRIVATE_TRANSFER_ID = 37
export const EXP_CATEGORY_PHOTOSHOOT_TRAVELSHOOT_ID = 43
export const EXP_CATEGORY_LUX_PLUS_ID = 66
export const EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID = 67
export const EXP_CATEGORY_GIFT_INSPIRATION = 56

export const EXPERIENCE_IN_FLOW_MAX_SHOWN = 12

export const EmptyExperienceList: NonNullable<App.ExperienceListState['']> = {
  ids: [],
  total: 0,
  fetching: true,
}

export const PROVIDERS: Record<string, string> = {
  led: 'led',
  rez: 'rezdy',
  dby: 'derbysoft',
  klo: 'klook',
  asp: 'aspire',
  cln: 'collinson',
  cmc: 'customlinc',
}

// Disney California Adventure offer IDs (all include both Disneyland and Disney California Adventure parks)
export const DISNEY_CALIFORNIA_OFFER_IDS = [
  'dby:disneyland',
  'dby:disneyland-aunz-exclusive',
  'dby:176e6b74-1611-42a8-80f7-964d8f3ed857',
  'dby:05e08d61-7750-47a7-958d-13d9a27f2f3b',
  'dby:disneyland-hopper', // deprecated but may still exist in data
] as const

// Disney Orlando (Walt Disney World) offer ID
export const DISNEY_ORLANDO_OFFER_ID = 'dby:walt-disney-world' as const

export const EXPERIENCES_SEARCH_COMPACT_TILES_AB_TEST_AI_TITLE_MESSAGES: Record<string, MessageDescriptor> = defineMessages({
  // Sydney
  'led:006RF00000L803bYAB': {
    id: 'WJjMvs1mUnhp21SN79sw',
    defaultMessage: '2.5-Hour Pub Crawl in The Rocks',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000HCxH7YAL': {
    id: 'Iwcl5KR3WliyGaKAVd3M',
    defaultMessage: 'Sydney Airport Lounge Access',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000KwQTFYA3': {
    id: 'RXtPx6222VQsx0OFtB9I',
    defaultMessage: 'Harbourfront 3-Course Meal for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000F0FcWAAV': {
    id: '9FXwDmg53c6vLu8A8Uyo',
    defaultMessage: '10-Course Indian Banquet at Manjit’s',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000JDfiLYAT': {
    id: 'z0H_4VH7wWUf-dRjb6AW',
    defaultMessage: 'Japanese Teppanyaki Banquet in The Rocks',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000KwR5yYAF': {
    id: '3W2I_Li_eJOcP1XoGVO6',
    defaultMessage: '4-Course Greek Feast for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbIDrAAN': {
    id: 'HK0jdA7PT90cDni_rerl',
    defaultMessage: '30-Min Shark Attack Jet Boat Ride',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000H6u5pYAB': {
    id: 'H0wOrvgKw7pXKZvh0Gur',
    defaultMessage: '9-Dish Asian Banquet for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000Knk9RYAR': {
    id: 'Gup7LHUXalR8VCeyqD70',
    defaultMessage: '12-Course Degustation at Quoi',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000KUv71YAD': {
    id: 'CeSWEIknW3q7qX9o2p-7',
    defaultMessage: '6-Course Winter Chalet Dining for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000FcBCjAAN': {
    id: '3lKZEddCtDo-pxxmqTds',
    defaultMessage: 'Spa Day with High Tea for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000I4nEHYAZ': {
    id: '2cAVTOB-03FnmpILcnkE',
    defaultMessage: 'Afternoon Tea at Hilton Sydney',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IcqdaAAB': {
    id: 'GQiuwXljdhoYM3fGxyay',
    defaultMessage: 'Massage or Facial with High Tea',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EE0mTYAT': {
    id: '_6HObdbXPm3uo8OsAUPw',
    defaultMessage: '8-Course French-Japanese Degustation',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000L2qMcYAJ': {
    id: 'YPkI_LJ-gYecRDnmNJfh',
    defaultMessage: 'Seafood Buffet Brunch at Sheraton',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000Gv1P7AAJ': {
    id: 'I8qo0fZzsHKYtD3ff45y',
    defaultMessage: 'Gin Distillery Tour with Tasting',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000HpDW7YAN': {
    id: 'neJLQQU77Kvwh2l67o2Z',
    defaultMessage: '2-Hour Sydney Harbour Kayak Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000JJvxJYAT': {
    id: '4JpvbEwTd00m2mDxRRpM',
    defaultMessage: 'Hunter Valley Food & Wine Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000IRTQBYA5': {
    id: 'OtQCX1YwxOd0rlAAwO4q',
    defaultMessage: 'Italian Tasting Menu for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EE005YAD': {
    id: '_9qOsMnW1vs7vI83u9aL',
    defaultMessage: '5-Course Tasting Menu at Luke’s',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000KQwG9YAL': {
    id: 'zrdCg7oROm73i21J0dh4',
    defaultMessage: '2-Hour Cocktails with Grazing Board',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000Dg1EsYAJ': {
    id: 'GLXmap3hG0rDqpX2Rpy5',
    defaultMessage: '5-Course Dining at Cottage Point',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000DpkDnAAJ': {
    id: 'eJGPNX6ens8Pwunkj5fO',
    defaultMessage: 'Waterfront High Tea at Ripples',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PYVWTZ': {
    id: '0oV6JkpJEoBp4NOMFnAE',
    defaultMessage: '1.5-Hour Sunset Harbour Cruise',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000DkeHVYAZ': {
    id: '5dYoMczS8bnHWWL5omYk',
    defaultMessage: 'High Tea at Akuna Bay for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000Ikb3qYAB': {
    id: '91Po_EQYw03qMnFfnXT7',
    defaultMessage: '3-Course Steakhouse Meal for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000IlZ3BYAV': {
    id: 'W48PaYHJ8-VPMmutNz2X',
    defaultMessage: 'Featherdale Wildlife Park Ticket',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000IkyLNYAZ': {
    id: 'GzLH7iSu2T5AIQKvl3RR',
    defaultMessage: 'Market Menu Dining at Sydney Common',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EE0RVYA1': {
    id: '42zE_0kBDRkMrdSJqItk',
    defaultMessage: 'Rooftop Rose & Dips Platter for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000KtCMqYAN': {
    id: 'KedEB33ec41f44oPVO12',
    defaultMessage: 'Sunrise Balloon Flight with Breakfast',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },

  // Brisbane
  'led:0062y00000Dp1FIAAZ': {
    id: 'el8_CeV8UxgcyyTd_MfY',
    defaultMessage: '80-Min Facial or 2-Hour Spa in Bulimba',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006Ii000002JJwsIAG': {
    id: 'mUdKYk1qdSW38AD0Sndc',
    defaultMessage: 'Brisbane Airport Lounge Access',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EH7OPYA1': {
    id: 'GmaNNUcnyOtrbHvPV1wi',
    defaultMessage: '70-Min Massage & Foot Soak in Brisbane',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnUtAAJ': {
    id: '2K3Czqu8QnBRFOeBuXMG',
    defaultMessage: '2-Hour Goodna Cemetery Ghost Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000Dp1OmAAJ': {
    id: 'Pt4c4uXfVbgxKBMeIsGC',
    defaultMessage: '2-Hour Spa Package with Wine in Brisbane',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PP2YUG': {
    id: 'XtWoyiVbKOhOqrSr6Sdd',
    defaultMessage: '2-Hour Moreton Bay Sunset Cruise',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006Ii000002I9GwIAK': {
    id: 'PAWDzNAbZfYCcm-x_WOm',
    defaultMessage: 'Italian Dinner for Two in Brisbane CBD',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EDYbhYAH': {
    id: 'xHN2HV0pbkksjkaBxI_0',
    defaultMessage: 'A$100 Dining Credit at Eagles Nest Bar',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EDVVmYAP': {
    id: 'lRPoZmgsUnmbEDngCcJ5',
    defaultMessage: '4 Cocktails & Cheese Platter for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000DNtKLAA1': {
    id: 'F_Hlqi75Zz0bLwNS9EcP',
    defaultMessage: 'Cielo Rooftop Cocktails & Cheese for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PXNR9P': {
    id: 'TRzN3DNrErQcdIxhxPcL',
    defaultMessage: 'White Ridge Farm Entry with Mini-Golf',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PX60YU': {
    id: '2RTIzruIs1TqeE-HDakR',
    defaultMessage: 'Daytime Story Bridge Climb with Photo',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000C0YafYAF': {
    id: 'dDCW17_Vfy6ikP5cDDaE',
    defaultMessage: '3-Course Italian Meal for Two in West End',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PQEYVT': {
    id: '-jBSPu35dC01DpOH9eOU',
    defaultMessage: 'Full-Day Stradbroke Island Sunset Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000H48q1YAB': {
    id: '-42QvLsDMD_9tWDgFj9q',
    defaultMessage: 'Seafood Feast & Wine Tasting for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PTMB07': {
    id: 'XlrGaZWuJ4ZZ_jMPSOSo',
    defaultMessage: 'Hop-On Hop-Off Tamborine Brewery Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnVPAAZ': {
    id: 'UqX-GzO7_--uO9aokrGo',
    defaultMessage: '2-Hour Toowong Cemetery Ghost Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000EDYwfYAH': {
    id: 'TEbHlHExSINXEIlVy6Uk',
    defaultMessage: '2 or 3-Course Dinner at Lamberts for Two',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:P65QSD': {
    id: 'VQ7Yk9XUSmoq0JViFnXr',
    defaultMessage: 'Moreton Bay Snorkel Cruise with Lunch',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000JRdhvAAD': {
    id: 'z0JkC-aQpExHff8J4VAL',
    defaultMessage: '2-Hour Pottery Wheel Class for Beginners',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000C0UVSYA3': {
    id: 'VxaO8DhoDydbKwxwJNH1',
    defaultMessage: '3-Course Italian Dining in Newstead',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnVKAAZ': {
    id: '4HIGVctqS0gdKDo7TXaq',
    defaultMessage: '2-Hour Toowong Cemetery Ghost Walk',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PQQFW2': {
    id: 'NdAITxxDJpD4EgAepHLD',
    defaultMessage: 'Full-Day Tamborine Winery Tour with Lunch',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000C25iWAAR': {
    id: 'lfTZin5-u5iEeqfLBvdN',
    defaultMessage: 'Sirromet Winery Tour with Lunch & Wine',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'rez:PMGXGV': {
    id: 'VH90ZRujrzT_j9v8ta_p',
    defaultMessage: '90-Min Fortitude Valley True Crime Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:006RF00000GCLDyYAP': {
    id: 'W9ciZAOuTQ3y-N_osX0b',
    defaultMessage: 'Half-Day Yacht Charter with Afternoon Tea',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnVGAAZ': {
    id: 'JV6tZQtKF3NE0QlhCt8d',
    defaultMessage: '2-Hour Haunted Ipswich CBD Ghost Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnV1AAJ': {
    id: 'MxnKkza9irocs33gVbHT',
    defaultMessage: '2-Hour Ipswich Cemetery Ghost Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000IbnUrAAJ': {
    id: 'wwBOWZEoHvppoZKURqWc',
    defaultMessage: '2-Hour Brisbane CBD Ghost Walking Tour',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
  'led:0062y00000DpTk8AAF': {
    id: '9hgdEqpvhveqbqJM8zql',
    defaultMessage: '2-Hour Spa Package in Clear Mountain',
    description: 'AI-selected compact experience tile title shown in the Sydney or Brisbane title experiment on the experiences search page',
  },
})

/**
 * Maps carousel analytics names (from BigQuery / admin portal) to the heading
 * text rendered on the Experiences landing page. Used by the ?carousel= query
 * param to scroll to the matching carousel section.
 *
 * Values must match the defaultMessage of each carousel's heading (intl).
 */
export const CAROUSEL_HEADING_TEXT: Record<string, string> = {
  'OfferList - EXPERIENCES - Recently Viewed Carousel': 'Recently viewed',
  'OfferList - EXPERIENCES - Experiences Top Three Carousel': 'Our top 3 experiences',
  'OfferList - EXPERIENCES - YAML Carousel': 'Local discounts exclusive to LuxPlus+ members',
  'OfferList - EXPERIENCES - Experiences Our exclusive experiences Carousel': 'Our exclusive experiences',
  'OfferList - EXPERIENCES - Experiences Top activities for you Carousel': 'Top activities for you',
  'OfferList - EXPERIENCES - Experiences Discover dining experiences Carousel': 'Discover dining experiences',
  'OfferList - EXPERIENCES - Experiences Explore your destination Carousel': 'Explore your destination',
  'OfferList - EXPERIENCES - Collections Carousel - Summer Highlights': 'Summer Highlights',
  'OfferList - EXPERIENCES - Collections Carousel - Things to Do with Kids': 'Things to Do with Kids',
  'OfferList - EXPERIENCES - Collections Carousel - Romantic Experiences': 'Romantic Experiences',
  'OfferList - EXPERIENCES - Collections Carousel - Perfect Gifts for Someone Special': 'Perfect Gifts for Someone Special',
  'OfferList - EXPERIENCES - Experiences See the sights Carousel': 'See the sights',
  'OfferList - EXPERIENCES - Experiences Live events Carousel': 'Live events',
  'OfferList - EXPERIENCES - Experiences Indulge yourself Carousel': 'Indulge yourself',
}

export type TransferType = 'AIRPORT-TO-HOTEL' | 'HOTEL-TO-AIRPORT' | 'ROUND-TRIP'
export type TransferTripTypeDisplayText = 'Round trip' | 'Airport to Hotel' | 'Hotel to Airport'

export interface BaliHotelLocation {
  name: string
  area: string
  zone: number
  placeId: string
}

export interface BaliHotelLocationsResponse {
  hotels: Array<BaliHotelLocation>
}
